import { Box, Pagination, styled, LinearProgress } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { ptBR, DataGrid } from '@mui/x-data-grid'
import { object, array, bool } from 'prop-types'
import MobileTable from './MobileTable'

const StyledBox = styled(Box)(({ theme }) => {
  return {
    [theme.breakpoints.down('md')]: {
      marginBottom: '40px'
    }
  }
})

const StyledPag = styled(Pagination)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    marginTop: '-10px'
  }
}))
const style = {
  '& .MuiDataGrid-columnSeparator': {
    visibility: 'hidden'
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
    textAlign: 'center'
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    display: 'flex',
    justifyContent: 'start!important'
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: 'white!important'
  }
}

const StyledDatagrid = styled(DataGrid)(({ theme }) => ({
  border: 'none',
  borderRadius: '0px',
  [theme.breakpoints.up('md')]: {
    height: '100%'
  },
  [theme.breakpoints.down('md')]: {
    height: '0.1px'
  },

  '& .MuiDataGrid-columnHeaders': {
    // backgroundColor: 'red'
  },

  '& ::-webkit-scrollbar-track': {
    backgroundColor: '#f5f5f5'
  },
  '& ::-webkit-scrollbar': {
    width: '4px',
    background: '#fff'
  },
  '& ::-webkit-scrollbar-thumb': {
    background: 'gray'
  },

  '& .MuiDataGrid-footerContainer': {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',

      height: 'max-content'
    },
    [theme.breakpoints.down('md')]: {
      display: 'flex'
    }
  },
  '& .MuiDataGrid-main': {
    minHeight: '1px'
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none'
  },
  '& .MuiDataGrid-cell': {
    /* overflow: hidden; */
    padding: '0.3rem 0',
    justifyContent: 'center',
    /* white-space: nowrap; */

    // background: 'chocolate',
    /* height: -webkit-fill-available; */
    maxHeight: 'none!important',
    height: 'auto!important',
    /* min-height: -webkit-fill-available!important; */
    whiteSpace: 'pre-wrap!important',
    '& .MuiDataGrid-cellContent': {
      // textTransform: 'lowercase!important',
      // background: 'red',
      width: '100%',
      margin: 'auto',
      padding: '0 0.75rem'
    },
    textAlign: 'center',
    fontSize: '0.85rem'
  },

  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& :nth-of-type(2n)': {
      // '&. MuiDataGrid-row': {
      background: 'rgba(24, 82, 115, 0.12)'
      // }
    }
  },
  '& .MuiDataGrid-columnHeaderInner': {
    '& :nth-of-type(1)': {
      padding: '0 1rem'
    }
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: 'rgb(220, 220, 220)!important',
    color: 'black',
    width: '100%',
    margin: '0',
    padding: '0',
    '& :nth-of-type(1)': {
      padding: '0 0.2rem'
    }
  },
  '& .MuiDataGrid-row': {
    /* overflow: hidden; */
    '& :nth-of-type(2n)': {
      backgroundColor: 'initial',
      background: 'initial'
    },

    maxHeight: 'none!important'
  }
}))

const BasicDatagrid = ({
  styles,
  rows,
  columns,
  pagination = {},
  loading,
  ...rest
}) => {
  const {
    lastPage = 0,
    currentPage = 0,
    action = () => {},
    active = false,
    type = 1
  } = pagination

  const [ld, setLd] = useState(false)

  useEffect(() => {
    if (loading === false) {
      if (ld === true)
        setTimeout(() => {
          setLd(false)
        }, 690)
    } else {
      setLd(loading)
    }
  }, [loading])

  const CustomPagination = () => {
    return (
      <StyledPag
        sx={{ display: 'block' }}
        color="leitura"
        count={lastPage}
        page={currentPage}
        onChange={(event, value) => {
          action({}, value)
        }}
      />
    )
  }

  columns = columns.filter(column => 'headerName' in column)

  const PaginationStyle =
    type === 1 ? { Pagination: active === true ? CustomPagination : false } : {}

  return (
    <>
      <StyledBox sx={{ ...style, ...styles }}>
        <MobileTable
          rows={rows}
          columns={columns}
          Pagination={CustomPagination}
        />
        <StyledDatagrid
          rows={rows}
          columns={columns}
          localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          disableSelectionOnClick
          components={{ ...PaginationStyle, LoadingOverlay: LinearProgress }}
          hideFooter={!active}
          {...rest}
          loading={ld}
        />
      </StyledBox>
    </>
  )
}

BasicDatagrid.propTypes = {
  styles: object,
  rows: array,
  columns: array,
  pagination: object,
  loading: bool
}

export default BasicDatagrid
